/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha32 = props => (
  <svg viewBox="0 0 30 30" width="1em" height="1em" {...props}>
    <defs>

      <clipPath id="clippath">
        <rect fill="none" x="4.03" y="19.34" width="10.51" height="7.51"/>
      </clipPath>
      <clipPath id="clippath-1">
        <rect fill="none" x="14.54" y="19.34" width="10.51" height="7.51"/>
      </clipPath>
    </defs>
    <g id="Sirkel">
      <g>
        <circle fill="#b79c9c" stroke="#231f20" strokeMiterlimit="10" strokeWidth=".1px" cx="14.73" cy="15" r="13.32"/>
        <polygon fill="#fff" stroke="#231f20" strokeMiterlimit="10" strokeWidth=".1px" points="1.66 17.74 14.82 17.74 27.71 17.74 1.66 17.74"/>
      </g>
      <circle fill="#fff" stroke="#231f20" strokeMiterlimit="10" strokeWidth=".5px" cx="14.73" cy="15" r="13.32"/>
      <polygon stroke="#231f20" strokeMiterlimit="10" strokeWidth="1px" points="1.66 17.74 14.82 17.74 27.71 17.74 1.66 17.74"/>
    </g>
    <g id="Mirrored_button" data-name="Mirrored button">
      <g clipPath="url(#clippath)">
        <path fill="#231f20" d="M14.67,26.86c-3.95,0-9.15-2.47-10.6-6.19-.08-.41-.03-.74.14-.98.22-.31.57-.35.58-.35h19.61v.1H4.8s-.31.04-.51.31c-.16.22-.2.52-.13.89,1.43,3.67,6.59,6.12,10.5,6.12.11,0,.22,0,.33,0v.1c-.11,0-.22,0-.33,0Z"/>
      </g>
      <g id="_Mirror_Repeat_" data-name="&amp;lt;Mirror Repeat&amp;gt;">
        <g >
          <g>
            <path fill="#fff" d="M4.67,19.39h19.61s.91.11.69,1.26c-1.49,3.84-6.94,6.3-10.88,6.15h.92c-3.95.14-9.4-2.32-10.88-6.15-.22-1.15.69-1.26.69-1.26h19.61"/>
            <path fill="#231f20" d="M14.41,26.86c-.11,0-.22,0-.33,0v-.1c.11,0,.22,0,.34,0,3.91,0,9.07-2.44,10.5-6.13.07-.37.03-.67-.13-.88-.2-.27-.51-.31-.52-.31H4.67v-.1h19.61s.37.05.59.35c.17.24.22.56.15.97-1.44,3.73-6.65,6.2-10.6,6.2Z"/>
          </g>
        </g>
      </g>
    </g>
    <g id="Ny_sirkel" data-name="Ny sirkel">
      <path fill="#b79c9c" stroke="#231f20" strokeMiterlimit="10" strokeWidth=".1px" d="M27.7,18H1.76"/>
      <path fill="#231f20" stroke="#231f20" strokeMiterlimit="10" strokeWidth=".1px" d="M14.73,1.68C7.37,1.68,1.41,7.64,1.41,15c0,1.03.13,2.03.35,3h25.94c.22-.97.35-1.97.35-3,0-7.36-5.96-13.32-13.32-13.32Z"/>
    </g>
  </svg>
);
export default extendIcon(Deha32);
